/* eslint-disable import/no-anonymous-default-export */
export default {
  isProduction: false,
  isBff: false,
  baseURL: process.env.REACT_APP_BASE_URL,
  apiSettings: {
    headers: {
      "Finsys-Platform-TenantId": process.env.REACT_APP_HEADER_FINSYSCORE_PLATFORM_TENANT_ID,
      Authorization: process.env.REACT_APP_HEADER_AUTHORIZATION,
    },
  },
};
